import { PhoneNumberUtil } from 'google-libphonenumber'

const phoneUtil = PhoneNumberUtil.getInstance()

/**
 * 從 E164 格式的電話號碼取得地區碼
 * @param {string} e164Number - E164 格式的電話號碼
 */
export function getRegionCodeFromE164(e164Number: string) {
  try {
    // 解析電話號碼
    const phoneNumber = phoneUtil.parse(e164Number)

    // 取得地區碼
    return phoneUtil.getRegionCodeForNumber(phoneNumber)
  } catch {
    return ''
  }
}
